import { render, staticRenderFns } from "./CheckboxField.vue?vue&type=template&id=61a2d5cf"
import script from "./CheckboxField.vue?vue&type=script&lang=js"
export * from "./CheckboxField.vue?vue&type=script&lang=js"
import style0 from "./CheckboxField.vue?vue&type=style&index=0&id=61a2d5cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports